module.exports = __webpack_public_path__ + "img/nip.3251db7c.svg";